var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"item",attrs:{"href":_vm.link,"target":"_blank","flat":"","tile":""}},[_c('img',{staticClass:"d-block mx-auto item-img",attrs:{"src":_vm.files + _vm.img,"alt":_vm.title}})])}
var staticRenderFns = []

export { render, staticRenderFns }